import axios from "axios";

export async function reqAdminAgree(reportIds) {
  return await axios.post(`/report/request-admin-agree`, reportIds);
}

export async function adminAgree(reportIds) {
  return await axios.post(`/report/admin-agree`, reportIds);
}

export async function updateScore(obj) {
  return await axios.post(`/report/update-scores`, obj);
}

export async function getData(reportName, grade) {
  return await axios.get(`/report/by-grade/${reportName}/${grade}`);
}

export async function getReportGradeStatus(reportName, grade) {
  return await axios.get(`/report-grade-status/by-name-and-grade/${reportName}/${grade}`);
}

export async function updateReportGradeStatus(reportName, grade, status) {
  return await axios.post(`/report-grade-status/update-status/${reportName}/${grade}/${status}`);
}

export async function updatePresenceFilled(reportName, grade) {
  return await axios.patch(`/report-grade-status/update-presence-filled/${reportName}/${grade}`);
}